import type { AuthUser, DaemonProfile } from "@/lib/auth-context";

export const PRODUCT_HOME = "/wallet";
export const PRODUCT_NAME = "GENRL Wallet";
export const PRODUCT_TAGLINE = "Wallet · Workloads · CRM · Store";

export function createWalletProfile(user?: Pick<AuthUser, "name" | "email"> | null): DaemonProfile {
  return {
    company: "Personal Workspace",
    userName: String(user?.name || "Wallet Owner").trim() || "Wallet Owner",
    email: String(user?.email || "").trim(),
    companyType: "hybrid",
    entityType: "hybrid",
    keepOnPerpetually: true,
  };
}
